import { Component, inject } from '@angular/core';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { LoyaltySettingsTable } from '@/table-settings/imports/loyalty-settings-table';
import { LoyaltyDataSource } from '@components/new-table/data-sources/loyalty.dataSource';

@Component({
  selector: 'app-loyalty-table',
  templateUrl: './loyalty-table.component.html',
  styleUrls: ['./loyalty-table.component.scss'],
})
export class LoyaltyTableComponent {
  displayedColumns: TableColumnsSetting<any>;

  dataSource = new LoyaltyDataSource(this.importFlowService);

  toastr = inject(ToastrService);
  dialog = inject(MatDialog);

  reloadTrigger$ = new Subject<any>();

  constructor(private importFlowService: ImportFlowService) {
    this.displayedColumns = LoyaltySettingsTable.getColumnsSetting();
  }
}
